import {
    queryFirst,
    addClass,
    removeClass,
    waitForElement,
    queryAll,
    toggleClass
} from './domUtil';
import { initRatingStarsObserver, removeRatingStarsObserver } from './bazaarvoice/detectRatingStarsActiveClass';
import { getStepClasses } from './bazaarvoice/detectActiveStepClass';

const { HIDDEN_CLASS, NO_SCROLL_CLASS, ACTIVE_CLASS } = require('./constants');
const REFS_TOKENS = {
    reviewsDialogContainer: 'div[data-bv-show="inpage_submission"]',
    reviewsDialogContainerAttr: 'inpage_submission',
    cancelButtonSelector: '#bv-ips-cancel',
    submitButtonSelector: '#bv-ips-submit',
    skipButtonSelector: '#bv-ips-skip',
    // Image guidelines dialog
    guideLinesButtonSelector: '#bv-ips-step-1 > section > div[type="fieldTitle"] button',
    guideLinesDisclosureSelector: '#bv-ips-step-1 > section > div[type="fieldTitle"] div[type="popup"]',
    guideLinesStepSectionSelector: '#bv-ips-step-1 > section', // assume that only one section is present
    // Dialogs/child dialogs
    dialogImageGuideSelector: 'div[role=dialog][aria-labelledby="bv-ips-guidelines-id"]',
    dialogReviewSelector: 'div[role=dialog][type="main"]',
    // Steps
    stepId: 'bv-ips-step-', // #bv-ips-step-0|1|2|3
    stepSelector: 'div[data-bv-show="inpage_submission"] fieldset',
    skippedStepSelector: 'span[color="#E76D25"]',
    // Button
    dialogCloseButtonSelector: '#bv-ips-loading-text_bv-ips-title + div > button',
    // Overall Rating element
    ratingLabelId: 'bv-label-text-rating',
    ratingErrorSelector: ':scope > div[type=error]',
    // Terms and conditions element
    termsAndConditionsLabelId: 'agreement-termsAndConditions',
    termsAndConditionsErrorSelector: '#agreement-termsAndConditions + div > div[type=error]',
    // No reviews state
    noReviewsTextString1: 'Be the first to review this product',
    noReviewsTextString2: 'No reviews have been submitted yet',

    // review text
    REVIEW_TEXT_SINGULAR: 'review',
    REVIEW_TEXT_PLURAL: 'reviews',

    // Tabs
    tabSelector: '.bv-tabs-tab',
    bvMainContainer: '.bv-reviews-main-container'
};
const { body } = document;
let activeStepClass = '';
let inactiveStepClass = '';
let imageStyleGuideDisclosure = null;
let imageStyleGuideButton = null;
let currentStepIndex = 0;
let currentEditedStep;

function addDialogListeners(reviewDialog) {
    reviewDialog.addEventListener('click', event => {
        const { target } = event;
        // listenCancelStepEditing
        if (target.closest(REFS_TOKENS.cancelButtonSelector) || target.closest(REFS_TOKENS.skipButtonSelector)) {
            //This applies to a case when a review has been submitted, and we want to change it.
            if (queryFirst(REFS_TOKENS.reviewsDialogContainer).classList.contains('bv-review-edited')) {
                currentEditedStep = target.closest(REFS_TOKENS.cancelButtonSelector).closest('fieldset');
            } else if (queryFirst(REFS_TOKENS.reviewsDialogContainer).classList.contains('bv-review-edited')) {
                currentEditedStep = target.closest(REFS_TOKENS.skipButtonSelector).closest('fieldset');
            } else {
                // This is a case when user have several steps skipped,
                // then he is goes to 1st step and instead of editing skip it again
                openStepIfExist(currentStepIndex + 1);
            }
        }
        // listen step re-submition
        if (target.closest(REFS_TOKENS.submitButtonSelector)) {
            // This is a case when user re-submit step (in form that he already submit)
            // we need to move him to next step, otherwise he will see empty dialog
            if (queryFirst(REFS_TOKENS.reviewsDialogContainer).classList.contains('bv-review-edited')) {
                currentEditedStep = target.closest(REFS_TOKENS.submitButtonSelector).closest('fieldset');
            } else {
                openStepIfExist(currentStepIndex + 1);
            }
        }
        // listen click on dialog backdrop
        if (
            target.hasAttribute('type')
            && (target.getAttribute('type') === 'main')
            && !target.hasAttribute('role')
        ) {
            queryFirst(REFS_TOKENS.dialogCloseButtonSelector).click();
        }
    });
}

function blockPageScroll(isBlocked) {
    if (isBlocked) {
        addClass(body, NO_SCROLL_CLASS);
    } else {
        removeClass(body, NO_SCROLL_CLASS);
    }
}

function addReviewButtonToReviews(container, text) {
    const host = queryFirst(container);
    if (!host) { return; }
    const button = document.createElement('button');
    button.textContent = text;
    button.setAttribute('id', 'bv-custom-write-review-button');
    button.setAttribute('type', 'button');
    button.addEventListener('click', (e) => {
        const reviewButton = queryFirst('.bv_button_buttonMinimalist');
        if (reviewButton) {
            reviewButton.click();
            removeClass(queryFirst(REFS_TOKENS.reviewsDialogContainer), 'bv-review-edited');
            currentEditedStep = null;
        }
    });
    host.insertAdjacentElement('beforeend', button);
}

function addNoReviewsTitle() {
    const reviewsContainer = queryFirst('#bv_review_maincontainer');
    if (!reviewsContainer) { return; }
    const title = document.createElement('h2');
    title.textContent = 'No reviews yet';
    title.setAttribute('id', 'bv-custom-write-review-title');
    reviewsContainer.insertAdjacentElement('beforeend', title);
}

function updateWriteAReviewButton() {
    const container = queryFirst('.rating-summary-container');
    const buttonEl = queryFirst('.bv_button_buttonMinimalist', container);
    const ratingTotalEl = queryFirst('[itemprop="reviewCount"]', container);

    if (ratingTotalEl && buttonEl) {
        const reviewsCount = ratingTotalEl.content;
        buttonEl.textContent = `${reviewsCount} ${Number(reviewsCount) === 1 ? REFS_TOKENS.REVIEW_TEXT_SINGULAR : REFS_TOKENS.REVIEW_TEXT_PLURAL}`;
    }
}

function changeButtonTextCase() {
    const writeAReviewButton = queryFirst('.rating-summary-container .bv_button_buttonMinimalist');
    if (writeAReviewButton) {
        // we need to change text to paragraph case
        const text = writeAReviewButton.textContent;
        writeAReviewButton.textContent = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    }
}

function waitReviewsDialogInsertion() {
    const reviewsDialogRootElement = queryFirst(REFS_TOKENS.reviewsDialogContainer, body);
    if (reviewsDialogRootElement) {
        reviewsDialogOpenCallback(reviewsDialogRootElement);

        return;
    }

    const inPageSubmissionDialogObserver = new MutationObserver((mutationRecords, observer) => {
        for (const mutation of mutationRecords) {
            if (mutation.type === "childList") {
                for (let i = 0, n = mutation.addedNodes.length; i < n; i++) {
                    const element = mutation.addedNodes[i];
                    if (
                        element instanceof HTMLElement
                        && element.getAttribute('data-bv-show') === REFS_TOKENS.reviewsDialogContainerAttr
                    ) {
                        // Reviews dialog container inserted only once. After close
                        // only inner elements is removed so we do not need to call
                        // callback only once.
                        reviewsDialogOpenCallback(element);
                        observer.disconnect();
                    }
                }
            }
        }
    });

    inPageSubmissionDialogObserver.observe(body, { childList: true });
}

function waitReviewsListInsertion() {
    const reviewsObserver = new MutationObserver((mutationRecords, observer) => {
        for (const mutation of mutationRecords) {
            if (mutation.type === "childList") {
                for (let i = 0, n = mutation.addedNodes.length; i < n; i++) {
                    const element = mutation.addedNodes[i];
                    if (element instanceof HTMLElement && element.classList.contains('bv_rating_content2')) {
                        addReviewButtonToReviews('#bv-reviews-overall-ratings-container', 'Write a review');
                        observer.disconnect();
                    }

                    if (element instanceof HTMLElement) {
                        const reviewContainer = queryFirst('#bv_review_maincontainer');
                        let hasNoReviewsText = false;

                        // Fix for sorting options that not opened on hover after selecting one of the options
                        const sortElement = queryFirst('div[aria-controls*="bv-reviews-sort"]', reviewContainer);
                        sortElement?.parentElement?.addEventListener('click', function () {
                            sortElement.focus();
                        });

                        // Remove word "Review" from pagination
                        const reviewWrapper = queryFirst('.next', reviewContainer)?.closest('div');
                        if (reviewWrapper) {
                            const reviewTextBlock = queryFirst('div', reviewWrapper);
                            if (reviewTextBlock?.textContent?.toLowerCase().indexOf('reviews')) {
                                const reviewUpdatedText = reviewTextBlock.textContent.toLowerCase().replace('reviews', '');
                                reviewTextBlock.textContent = reviewUpdatedText;
                            }
                        }

                        const divs = queryAll('div', reviewContainer);
                        for (let c = 0, j = divs.length; c < j; c++) {
                            const noReviewsTextContainer = divs[c];
                            // This text is the only thing that differentiate empty reviews
                            if (
                                noReviewsTextContainer.textContent.includes(REFS_TOKENS.noReviewsTextString1)
                                || noReviewsTextContainer.textContent.includes(REFS_TOKENS.noReviewsTextString2)
                            ) {
                                hasNoReviewsText = true;
                                break;
                            }
                        }

                        const customNoReivewsTitle = queryFirst('#bv-custom-write-review-title', reviewContainer);
                        if (hasNoReviewsText && !customNoReivewsTitle) {
                            addNoReviewsTitle();
                            addReviewButtonToReviews('#bv_review_maincontainer', 'Be the first to write a review');
                            observer.disconnect();
                        }
                    }
                }
            }
        }
    });

    const bazaarvoiceReviewsEl = queryFirst('#bazaarvoiceReviews');
    if (bazaarvoiceReviewsEl) {
        reviewsObserver.observe(bazaarvoiceReviewsEl, { childList: true, subtree: true });
    }
}

function reviewsDialogOpenCallback(targetElement) {
    observeReviewsDialogInnerChanges(targetElement);
    addDialogListeners(targetElement);
}

function toggleErrorClass(element, isInvalid) {
    if (!element) { return; }
    toggleClass(element, 'm-invalid', isInvalid);
}

function moveImageStyleGuideButton() {
    if (imageStyleGuideButton) {
        return;
    }
    const guideLinesButton = queryFirst(REFS_TOKENS.guideLinesButtonSelector);
    const stepSection = queryFirst(REFS_TOKENS.guideLinesStepSectionSelector);
    if (stepSection && guideLinesButton) {
        stepSection.after(guideLinesButton);
        guideLinesButton.setAttribute('aria-controls', 'imageGuideContent');
        guideLinesButton.setAttribute('aria-expanded', 'false');
        guideLinesButton.removeAttribute('aria-label');
        guideLinesButton.addEventListener('click', toggleStyleGuideContent);
        imageStyleGuideButton = guideLinesButton;
    }
}

function changeImageGuidesRole(button, content) {
    content.setAttribute('id', 'imageGuideContent');
    const dialogElement = content.children[0];
    dialogElement.removeAttribute('role');
    dialogElement.removeAttribute('aria-modal');
}

function moveImageStyleGuideContent() {
    if (imageStyleGuideDisclosure) return;

    const guideLinesButton = imageStyleGuideButton;
    const guideLinesDisclosure = queryFirst(REFS_TOKENS.guideLinesDisclosureSelector);

    if (guideLinesButton && guideLinesDisclosure) {
        guideLinesButton.after(guideLinesDisclosure);
        imageStyleGuideDisclosure = guideLinesDisclosure;
        changeImageGuidesRole(guideLinesButton, guideLinesDisclosure);
    }
}

function removeImageStyleGuideButton() {
    if (imageStyleGuideButton) {
        imageStyleGuideButton.remove();
        imageStyleGuideButton = null; // remove ref for GC and conditions
    }
    if (imageStyleGuideDisclosure) {
        imageStyleGuideDisclosure.remove();
        imageStyleGuideDisclosure = null;
    }
}

function toggleStyleGuideContent() {
    const guideLinesButton = imageStyleGuideButton;
    const guideLinesDisclosure = imageStyleGuideDisclosure;

    if (guideLinesButton.getAttribute('aria-expanded') === 'false') {
        guideLinesButton.setAttribute('aria-expanded', 'true');
        // since we assign listener before content is moved
        // in first call we will have guideLinesDisclosure === null .
        // This is expected and removeClass will handle it.
        removeClass(guideLinesDisclosure, HIDDEN_CLASS);
    } else {
        guideLinesButton.setAttribute('aria-expanded', 'false');
        addClass(guideLinesDisclosure, HIDDEN_CLASS);
    }
}

function removeBackButton() {
    const existingButton = document.getElementById('bv-custom-back-button'); // this ID created by us
    if (existingButton) {
        existingButton.remove();
    }
}

function insertBackButton(text, activeStepElement, prevStepIndex) {
    const prevStep = document.getElementById(REFS_TOKENS.stepId + prevStepIndex);
    const button = document.createElement('button');
    button.innerHTML = text;
    button.setAttribute('id', 'bv-custom-back-button');
    button.setAttribute('type', 'button');
    button.addEventListener('click', (e) => {
        const editButton = queryFirst('button', prevStep); // it is single element into simplified header
        if (editButton) {
            addClass(queryFirst(REFS_TOKENS.reviewsDialogContainer), 'bv-review-edited');
            editButton.click();
        }
    });
    removeBackButton();
    activeStepElement.closest('[role="dialog"]')?.firstChild.insertAdjacentElement('afterbegin', button);
}

function openStepIfEdited(currentEditedStep) {
    const nextStep = currentEditedStep.nextSibling;
    if (!nextStep) {
        queryFirst(REFS_TOKENS.dialogCloseButtonSelector).click();

        return;
    };
    const editButton = nextStep.querySelector('button');
    // We need extra precission here, because sometimes we could have situation
    // when this selector match button from other step
    if (editButton && editButton.textContent === 'Edit') {
        editButton.click();
    }
}

function openStepIfExist(stepNumber) {
    const step = document.getElementById(REFS_TOKENS.stepId + stepNumber);
    if (!step) return;
    const editButton = step.querySelector('button');
    // We need extra precission here, because sometimes we could have situation
    // when this selector match button from other step
    if (editButton && editButton.textContent === 'Edit') {
        editButton.click();
    }
}

function openLastSkippedStepIfAllStepsClosed() {
    const steps = queryAll(REFS_TOKENS.stepSelector);
    let isAllStepsClosed = true;
    let skippedSteps = [];
    steps.forEach(step => {
        if (step.id && step.id.includes(REFS_TOKENS.stepId)) {
            if (step.classList.contains(activeStepClass)) {
                isAllStepsClosed = false;
            }
            const skipMark = queryFirst(REFS_TOKENS.skippedStepSelector, step);
            if (skipMark) {
                const activeStepIndex = getStepIndex(step);
                // to have possibility to skip current step we need to move user to any not current step
                if (activeStepIndex !== currentStepIndex) {
                    skippedSteps.push(step);
                }
            }
        }
    });
    if (isAllStepsClosed) {
        if (skippedSteps.length) {
            // go to last skipped steps since it is closer to user journey 1st-2-3-4(finish)
            const lastSkippedStepIndex = getStepIndex(skippedSteps[skippedSteps.length - 1]);
            openStepIfExist(lastSkippedStepIndex);
        } else {
            // go to form last step if no skipped steps left.
            // Otherwise, user will see empty form
            openStepIfExist(steps.length - 1);
        }
    }
}

function getStepIndex(element) {
    let stepIndex = 0;
    if (element.id) {
        stepIndex = parseInt(element.id.match(/\d$/g)[0]);
    }
    return isNaN(stepIndex) ? 0 : stepIndex;
}

function updateImageCaption() {
    const uploadInput = queryFirst('#bv-ips-photo-upload-input');
    if (uploadInput) {
        const imageContainer = uploadInput.parentElement;
        const addImageStep = new MutationObserver((mutationImages, observer) => {
            for (const mutation of mutationImages) {
                if (mutation.type === "childList") {
                    for (let i = 0, n = mutation.addedNodes.length; i < n; i++) {
                        const element = mutation.addedNodes[i];
                        if (
                            element instanceof HTMLElement
                        ) {
                            const closeBtn = queryFirst('div > div[type="focus"] div[role="button"]', imageContainer);

                            if (closeBtn?.getAttribute('id')?.includes('bv-ips-offscreen-round-close-button')) {
                                closeBtn.addEventListener('click', function () {
                                    const nextImageElement = this.parentElement.parentElement.nextElementSibling;
                                    if (nextImageElement) {
                                        const nextImageElementImg = queryFirst('img', nextImageElement);
                                        const nextImageElementBtn = nextImageElementImg?.closest('div[role="button"]');
                                        nextImageElementBtn?.click();
                                    }
                                });

                            }
                        }
                    }
                }
            }
        });

        addImageStep.observe(imageContainer, { childList: true, subtree: true });
    }
}

function onStepChange(activeStepElement, isStepActivated) {
    const activeStepIndex = getStepIndex(activeStepElement);

    if (isStepActivated) {
        // On step activation
        switch (activeStepIndex) {
            case 0:
                removeBackButton();
                initRatingStarsObserver();
                break;
            case 1:
                moveImageStyleGuideButton();
                insertBackButton('Go back & edit personal/product info', activeStepElement, 0);
                break;
            case 2:
                insertBackButton('Go back & edit photos', activeStepElement, 1);
                break;
            case 3:
                insertBackButton('Go back & edit Height and Wearing', activeStepElement, 2);
                break;
        }
        currentStepIndex = activeStepIndex;

        updateImageCaption();

        // Reset scroll position to top when navigating between steps (app only)
        if (!queryFirst('.page')) {
            const dialog = activeStepElement.closest('[role="dialog"]');
            if (dialog) {
                dialog.scrollTop = 0;
            }
        }
    } else {
        switch (activeStepIndex) {
            case 0:
                removeRatingStarsObserver();
                break;
            case 1:
                removeImageStyleGuideButton();
                break;
        }

        if (currentEditedStep) {
            //This applies to a case when a review has been submitted, and we want to change it.
            openStepIfEdited(currentEditedStep);
        } else {
            // On any step deactivation
            // When user try to re-submit form and have for example 1 and last step
            // submitted click on Cancel or Skip will lead BV to shows summary of steps
            // (this summary hidden in our design) for this case we need to open last
            // skipped steps for the user. Otherwise, user will see just empty form.
            openLastSkippedStepIfAllStepsClosed();
        }
    }
}

function observeReviewsDialogInnerChanges(reviewDialog) {
    const config = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    };

    const callback = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === "childList") {
                for (let i = 0, n = mutation.addedNodes.length; i < n; i++) {
                    const element = mutation.addedNodes[i];
                    if (element instanceof HTMLElement) {
                        if ( // image guideline dialog inserted
                            element.querySelector(REFS_TOKENS.dialogImageGuideSelector)
                        ) {
                            moveImageStyleGuideContent();
                        }

                        if ( // reviews dialog opened/reopened
                            element.querySelector(REFS_TOKENS.dialogReviewSelector)
                        ) {
                            // remove page scroll to avoid double scroll
                            blockPageScroll(true);
                        }

                        // we need to wait after steps elements is inserted
                        if (element.querySelector('#' + REFS_TOKENS.stepId + '0')) {
                            // In case if user skip review submit and open dialog
                            // again we need to show him last step, otherwise he
                            // will just see a header without any action buttons
                            // in case if user not interact with dialog yet
                            // all other steps will not be opened
                            openStepIfExist(3);

                            // get active/inactive step classes
                            // should be after openStepIfExist since we have case
                            // where all steps are closed
                            const stepClasses = getStepClasses();
                            activeStepClass = stepClasses.activeStepClass;
                            inactiveStepClass = stepClasses.inactiveStepClass;
                        }

                        // When user already submit the review we will be landed
                        // to first skipped step. In this case classes would not
                        // be changed and change will not be triggered
                        // Alternatively could be fieldset[id*=bv-ips-step] > section
                        if (activeStepClass) { // since it called on every mutation, it could be before steps inserted and we get active class
                            const activeStep = queryFirst('fieldset.' + activeStepClass, element);
                            if (activeStep) {
                                onStepChange(activeStep, true);
                            }
                        }
                    }
                }
                for (let c = 0, j = mutation.removedNodes.length; c < j; c++) {
                    const element = mutation.removedNodes[c];
                    if (element instanceof HTMLElement) {
                        if ( // reviews dialog closed
                            element.querySelector(REFS_TOKENS.dialogReviewSelector)
                        ) {
                            blockPageScroll(false);
                            imageStyleGuideDisclosure = false;
                            imageStyleGuideButton = false;
                            currentStepIndex = 0;
                        }
                    }
                }
            }

            if (mutation.type === "attributes" && mutation.attributeName === 'class') {
                const mutationTarget = mutation.target;

                if (mutationTarget.id.includes(REFS_TOKENS.stepId)) {
                    if (mutationTarget.classList.contains(activeStepClass)) {
                        onStepChange(mutationTarget, true);
                    } else if (mutationTarget.classList.contains(inactiveStepClass)) {
                        onStepChange(mutationTarget, false);
                    }
                }

                // To have stars Label highlight on error we need this fix
                if (mutationTarget.id.includes(REFS_TOKENS.ratingLabelId)) {
                    const closestSection = mutationTarget.closest('section');
                    toggleErrorClass(
                        closestSection,
                        !!closestSection.querySelector(REFS_TOKENS.ratingErrorSelector),
                    )
                }

                // To not reliy on class we need to have stable selector on Terms and Conditions checkbox
                if (mutationTarget.id.includes(REFS_TOKENS.termsAndConditionsLabelId)) {
                    toggleErrorClass(
                        mutationTarget,
                        !!mutationTarget.parentElement.querySelector(REFS_TOKENS.termsAndConditionsErrorSelector),
                    )
                }
            }
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(reviewDialog, config);
}

function waitMiniRatingInsertion() {
    const host = queryFirst('.rating-summary-container');

    const miniRatingObserver = new MutationObserver((mutationRecords, observer) => {
        for (const mutation of mutationRecords) {
            if (mutation.type === "childList") {
                for (let i = 0, n = mutation.addedNodes.length; i < n; i++) {
                    const element = mutation.addedNodes[i];
                    if (
                        element instanceof HTMLElement
                        && element.classList.contains('bv_ratings_summary')
                    ) {
                        updateWriteAReviewButton();
                        changeButtonTextCase();
                        observer.disconnect();
                    }
                }
            }
        }
    });

    miniRatingObserver.observe(host, { childList: true, subtree: true });
}

/**
 * capitalizes the first letter of each sentence and convert the rest to lowercase
 */
function toSentenceCase() {
    setTimeout(() => {
        const selector = '#bv_review_maincontainer>div:nth-of-type(5)>div:nth-of-type(2) div[aria-label^=Menu]';
        const elements = queryAll(selector);

        elements.forEach(element => {
            const text = element.textContent;
            if (text) {
                element.textContent = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            }
        });
    }, 1000);
}

const BV_QA_PAGE_SIZE = 8;

/**
 * Parses the total question count from BV's SEO metadata (tq_N in BVSEO_meta).
 * Falls back to counting DOM elements if metadata is unavailable.
 */
function getBVTotalQuestions(container) {
    const coMeta = queryFirst('[data-bvseo="co"]', container);
    if (coMeta) {
        const match = coMeta.textContent.match(/tq_(\d+)/);
        if (match) return parseInt(match[1], 10);
    }
    return queryAll('.bvseo-question-answer', container).length;
}

/**
 * Adds Q: and A: labels to question-answer items that don't already have them.
 */
function addQALabels(items) {
    items.forEach(item => {
        const question = queryFirst('.bvseo-question', item);
        const answer = queryFirst('.bvseo-answer', item);

        if (question && !queryFirst('.bvseo-label', question)) {
            const qLabel = document.createElement('span');
            qLabel.className = 'bvseo-label';
            qLabel.textContent = 'Q:';
            question.insertBefore(qLabel, question.firstChild);
        }
        if (answer && !queryFirst('.bvseo-label', answer)) {
            const aLabel = document.createElement('span');
            aLabel.className = 'bvseo-label';
            aLabel.textContent = 'A:';
            answer.insertBefore(aLabel, answer.firstChild);
        }
    });
}

/**
 * Fetches a BV SEO pagination page, extracts .bvseo-question-answer elements,
 * and appends them to the questions container.
 * @param {string} url - The pagination URL to fetch
 * @param {HTMLElement} questionsSection - The #bvseo-questionsSection element
 * @returns {Promise<HTMLElement[]>} The newly appended question-answer elements
 */
async function fetchQAPage(url, questionsSection) {
    const response = await fetch(url);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newItems = queryAll('.bvseo-question-answer', doc);
    const newPagination = queryFirst('#bvseo-paginationSection', doc);

    newItems.forEach(item => {
        item.style.display = 'none';
        questionsSection.appendChild(item);
    });
    addQALabels(newItems);

    // Return the next page URL if there is one
    const nextLink = newPagination ? queryFirst('.bvseo-paginationLink', newPagination) : null;
    return {
        items: newItems,
        nextPageUrl: nextLink ? nextLink.getAttribute('href') : null
    };
}

/**
 * Paginates Q&A items with lazy-loading.
 * Shows 8 questions per page, fetches additional pages from BV on "Next" click.
 */
function initQAPagination(questionsPanel) {
    const questionsSection = queryFirst('#bvseo-questionsSection', questionsPanel);
    if (!questionsSection) return;

    let allItems = queryAll('.bvseo-question-answer', questionsSection);
    let currentPage = 1;
    let isLoading = false;

    // Get the next page URL from BV's SEO pagination
    const seoPagination = queryFirst('#bvseo-paginationSection', questionsPanel);
    let nextPageUrl = null;
    if (seoPagination) {
        const nextLink = queryFirst('.bvseo-paginationLink', seoPagination);
        nextPageUrl = nextLink ? nextLink.getAttribute('href') : null;
        seoPagination.style.display = 'none';
    }

    // Don't add pagination if all items fit on one page and there's no next page
    if (allItems.length <= BV_QA_PAGE_SIZE && !nextPageUrl) return;

    // Prefetch all remaining pages in the background
    let prefetchPromise = null;
    function prefetchAllPages() {
        if (prefetchPromise || !nextPageUrl) return prefetchPromise;
        prefetchPromise = (async () => {
            while (nextPageUrl) {
                try {
                    const result = await fetchQAPage(nextPageUrl, questionsSection);
                    allItems = queryAll('.bvseo-question-answer', questionsSection);
                    nextPageUrl = result.nextPageUrl;
                } catch (e) {
                    break;
                }
            }
        })();
        return prefetchPromise;
    }

    // Build pagination controls
    const paginationEl = document.createElement('div');
    paginationEl.className = 'bv-faqs-pagination';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'bv-faqs-pagination-btn bv-faqs-pagination-prev';
    prevBtn.setAttribute('type', 'button');
    prevBtn.setAttribute('aria-label', 'Previous questions');

    const nextBtn = document.createElement('button');
    nextBtn.className = 'bv-faqs-pagination-btn bv-faqs-pagination-next';
    nextBtn.setAttribute('type', 'button');
    nextBtn.setAttribute('aria-label', 'Next questions');

    const countText = document.createElement('span');
    countText.className = 'bv-faqs-pagination-count';

    paginationEl.appendChild(countText);
    paginationEl.appendChild(prevBtn);
    paginationEl.appendChild(nextBtn);
    questionsPanel.appendChild(paginationEl);

    // Use BV metadata for the true total, not just DOM count
    const knownTotal = getBVTotalQuestions(questionsPanel);

    function updateCount(start, end) {
        // Use the greater of known total vs DOM items (in case we've fetched all)
        const total = Math.max(knownTotal, allItems.length);
        countText.textContent = start + 1 + ' \u2013 ' + end + ' of ' + total;

        const headerCount = queryFirst('.bv-faqs-count', questionsPanel);
        if (headerCount) {
            headerCount.textContent = start + 1 + '-' + end + ' of ' + total + (total === 1 ? ' Question' : ' Questions');
        }
    }

    function showPage(page, scroll) {
        currentPage = page;
        const start = (page - 1) * BV_QA_PAGE_SIZE;
        const end = Math.min(start + BV_QA_PAGE_SIZE, allItems.length);

        allItems.forEach((item, i) => {
            item.style.display = i >= start && i < end ? '' : 'none';
        });

        updateCount(start, end);
        prevBtn.disabled = page === 1;
        // Disable next only if we're on the last page AND there's no more to fetch
        const totalPages = Math.ceil(allItems.length / BV_QA_PAGE_SIZE);
        nextBtn.disabled = page === totalPages && !nextPageUrl;

        if (scroll) {
            const heading = queryFirst('.bv-faqs-heading', questionsPanel);
            if (heading) heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    prevBtn.addEventListener('click', () => {
        if (currentPage > 1) showPage(currentPage - 1, true);
    });

    nextBtn.addEventListener('click', async () => {
        // Wait for prefetch if it's in progress
        if (prefetchPromise) {
            addClass(nextBtn, 'bv-faqs-pagination-loading');
            await prefetchPromise;
            allItems = queryAll('.bvseo-question-answer', questionsSection);
            removeClass(nextBtn, 'bv-faqs-pagination-loading');
        }

        const totalPages = Math.ceil(allItems.length / BV_QA_PAGE_SIZE);
        if (currentPage < totalPages) {
            showPage(currentPage + 1, true);
        } else if (nextPageUrl && !isLoading) {
            // Fallback: fetch directly if prefetch didn't load items
            isLoading = true;
            addClass(nextBtn, 'bv-faqs-pagination-loading');
            try {
                const result = await fetchQAPage(nextPageUrl, questionsSection);
                allItems = queryAll('.bvseo-question-answer', questionsSection);
                nextPageUrl = result.nextPageUrl;
                showPage(currentPage + 1, true);
            } catch (e) {
            } finally {
                isLoading = false;
                removeClass(nextBtn, 'bv-faqs-pagination-loading');
            }
        }
    });

    showPage(1, false);

    return { prefetchAllPages };
}

/**
 * Activates the selected tab and its panel, deactivating others.
 * @param {HTMLElement} selectedTab - The tab button to activate
 */
function switchTab(selectedTab) {
    const tablist = selectedTab.closest('[role="tablist"]');
    if (!tablist) return;

    const tabs = queryAll(REFS_TOKENS.tabSelector, tablist);
    const container = tablist.closest(REFS_TOKENS.bvMainContainer);

    tabs.forEach(tab => {
        const isSelected = tab === selectedTab;
        tab.setAttribute('aria-selected', String(isSelected));
        tab.setAttribute('tabindex', isSelected ? '0' : '-1');
        removeClass(tab, ACTIVE_CLASS);
        if (isSelected) addClass(tab, ACTIVE_CLASS);

        const panel = queryFirst('#' + tab.getAttribute('aria-controls'), container);
        if (panel) {
            if (isSelected) {
                addClass(panel, ACTIVE_CLASS);
            } else {
                removeClass(panel, ACTIVE_CLASS);
            }
        }
    });
}

/**
 * Builds the tab bar and applies panel roles to existing DOM elements.
 * Called on DOMContentLoaded — no ISML override needed.
 */
function initBVTabs() {
    const mainContainer = queryFirst(REFS_TOKENS.bvMainContainer);
    if (!mainContainer) return;

    const reviewsPanel = queryFirst('.reviews', mainContainer);
    const questionsPanel = queryFirst('.row.questions', mainContainer);
    if (!reviewsPanel) return;

    // Remove the <hr> separator between reviews and Q&A
    const hr = queryFirst('hr', mainContainer);
    if (hr) hr.remove();

    // Set up reviews panel attributes
    reviewsPanel.setAttribute('id', 'bv-panel-reviews');
    reviewsPanel.setAttribute('role', 'tabpanel');
    reviewsPanel.setAttribute('aria-labelledby', 'bv-tab-reviews');
    addClass(reviewsPanel, 'bv-tabs-panel', ACTIVE_CLASS);

    // Build tab bar
    const tablist = document.createElement('div');
    tablist.className = 'bv-tabs';
    tablist.setAttribute('role', 'tablist');

    const reviewsTab = document.createElement('button');
    reviewsTab.className = 'bv-tabs-tab active';
    reviewsTab.setAttribute('role', 'tab');
    reviewsTab.setAttribute('id', 'bv-tab-reviews');
    reviewsTab.setAttribute('aria-selected', 'true');
    reviewsTab.setAttribute('aria-controls', 'bv-panel-reviews');
    reviewsTab.setAttribute('tabindex', '0');
    reviewsTab.textContent = 'Reviews & Ratings';
    tablist.appendChild(reviewsTab);

    // Show FAQs tab only if product has Q&A content (server-rendered SEO section)
    const hasQuestions = !!queryFirst('#bvseo-questionsSection', mainContainer);
    let pagination = null;

    if (questionsPanel && hasQuestions) {
        questionsPanel.setAttribute('id', 'bv-panel-faqs');
        questionsPanel.setAttribute('role', 'tabpanel');
        questionsPanel.setAttribute('aria-labelledby', 'bv-tab-faqs');
        addClass(questionsPanel, 'bv-tabs-panel');

        // Add section heading
        const faqsHeading = document.createElement('h2');
        faqsHeading.className = 'bv-faqs-heading';
        faqsHeading.textContent = 'Frequently asked questions';
        questionsPanel.insertBefore(faqsHeading, questionsPanel.firstChild);

        // Add question count using BV metadata for accurate total
        const totalQuestions = getBVTotalQuestions(questionsPanel);
        if (totalQuestions > 0) {
            const countEl = document.createElement('p');
            countEl.className = 'bv-faqs-count';
            const end = Math.min(BV_QA_PAGE_SIZE, totalQuestions);
            countEl.textContent = '1-' + end + ' of ' + totalQuestions + (totalQuestions === 1 ? ' Question' : ' Questions');
            faqsHeading.insertAdjacentElement('afterend', countEl);
        }

        // Add Q: and A: labels to each question-answer block
        addQALabels(queryAll('.bvseo-question-answer', questionsPanel));

        // Initialize pagination
        pagination = initQAPagination(questionsPanel);

        const faqsTab = document.createElement('button');
        faqsTab.className = 'bv-tabs-tab';
        faqsTab.setAttribute('role', 'tab');
        faqsTab.setAttribute('id', 'bv-tab-faqs');
        faqsTab.setAttribute('aria-selected', 'false');
        faqsTab.setAttribute('aria-controls', 'bv-panel-faqs');
        faqsTab.setAttribute('tabindex', '-1');
        faqsTab.textContent = 'FAQs';
        tablist.appendChild(faqsTab);
    }

    // Insert tab bar before the reviews panel
    mainContainer.insertBefore(tablist, reviewsPanel);

    // Tab click handler
    tablist.addEventListener('click', e => {
        const tab = e.target.closest(REFS_TOKENS.tabSelector);
        if (tab) {
            switchTab(tab);
            // Prefetch remaining Q&A pages when FAQs tab is activated
            if (tab.id === 'bv-tab-faqs' && pagination) {
                pagination.prefetchAllPages();
            }
        }
    });

    // Arrow key navigation
    tablist.addEventListener('keydown', e => {
        const tabs = queryAll(REFS_TOKENS.tabSelector, tablist).filter(t => t.offsetParent !== null);
        const currentIndex = tabs.indexOf(e.target);
        if (currentIndex === -1) return;

        let nextIndex;
        if (e.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        } else if (e.key === 'Home') {
            nextIndex = 0;
        } else if (e.key === 'End') {
            nextIndex = tabs.length - 1;
        } else {
            return;
        }

        e.preventDefault();
        tabs[nextIndex].focus();
        switchTab(tabs[nextIndex]);

        if (tabs[nextIndex].id === 'bv-tab-faqs' && pagination) {
            pagination.prefetchAllPages();
        }
    });
}

function bvReadyCallbacks() {
    waitMiniRatingInsertion();
    waitReviewsDialogInsertion();
    toSentenceCase();
}

window.addEventListener('DOMContentLoaded', () => {
    initBVTabs();
    waitReviewsListInsertion();
    if (window.$BV) {
        bvReadyCallbacks();
        //NB: $BV.ready() not stable sometimes it fired before or after BV UI applied
    } else {
        waitForElement('script[src*=bv]').then(bvReadyCallbacks);
    }
});
